/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageDataOrderInfoForClientSkuVo } from './PageDataOrderInfoForClientSkuVo';
import {
    PageDataOrderInfoForClientSkuVoFromJSON,
    PageDataOrderInfoForClientSkuVoFromJSONTyped,
    PageDataOrderInfoForClientSkuVoToJSON,
    PageDataOrderInfoForClientSkuVoToJSONTyped,
} from './PageDataOrderInfoForClientSkuVo';

/**
 * 
 * @export
 * @interface ResponsePageDataOrderInfoForClientSkuVo
 */
export interface ResponsePageDataOrderInfoForClientSkuVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePageDataOrderInfoForClientSkuVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePageDataOrderInfoForClientSkuVo
     */
    message?: string;
    /**
     * 
     * @type {PageDataOrderInfoForClientSkuVo}
     * @memberof ResponsePageDataOrderInfoForClientSkuVo
     */
    data?: PageDataOrderInfoForClientSkuVo;
}

/**
 * Check if a given object implements the ResponsePageDataOrderInfoForClientSkuVo interface.
 */
export function instanceOfResponsePageDataOrderInfoForClientSkuVo(value: object): value is ResponsePageDataOrderInfoForClientSkuVo {
    return true;
}

export function ResponsePageDataOrderInfoForClientSkuVoFromJSON(json: any): ResponsePageDataOrderInfoForClientSkuVo {
    return ResponsePageDataOrderInfoForClientSkuVoFromJSONTyped(json, false);
}

export function ResponsePageDataOrderInfoForClientSkuVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePageDataOrderInfoForClientSkuVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PageDataOrderInfoForClientSkuVoFromJSON(json['data']),
    };
}

export function ResponsePageDataOrderInfoForClientSkuVoToJSON(json: any): ResponsePageDataOrderInfoForClientSkuVo {
    return ResponsePageDataOrderInfoForClientSkuVoToJSONTyped(json, false);
}

export function ResponsePageDataOrderInfoForClientSkuVoToJSONTyped(value?: ResponsePageDataOrderInfoForClientSkuVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PageDataOrderInfoForClientSkuVoToJSON(value['data']),
    };
}

